<div class="relative pt-10 m-0 p-1.5 sm:pt-10 px-3 pb-3 border border-[#d9d9d9] bg-[#FBFBFB] min-h-[120px] text-[#333] rounded-[10px]">
    <div class="w-full max-w-5xl mx-auto overflow-hidden">
      <div class="cursor-pointer absolute top-2.5 left-[28px] transform -translate-x-1/2 z-5 text-sm text-[#595959]">
        <button (click)="toggleAutoplay()" class="cursor-pointer">
          <span class="text-xl">{{ isPlaying() ? '⏸':'▶' }}
          </span>
        </button>
      </div>
  
      <div class="flex transition-transform duration-500"
      [ngClass]="{'slider-lg': !isSmallScreen, 'slider-sm': isSmallScreen}"
      [style.transform]="'translateX(-' + (currentIndex() * slideWidth) + '%)'">
      @for(group of slideGroups();track $index){
        <div class="min-w-full flex gap-4 px-2">
            @for(slide of group; track $index){
                <a 
                  [href]="slide.isnew ? wadhwaniUrl :trainingUrl+slide.id" 
                  class="cursor-pointer w-full lg:w-1/2">
                    <div [ngClass]="slide.isnew ? 'border border-[#8B4200]' : 'border border-[#0d64a4]'"
                         class="flex rounded min-h-[100px] max-h-[100px]">
                      @if(slide.isnew){
                        <div class="card-left-wad rounded-l !bg-white">
                          <div class="flex items-center justify-between">
                            <img [src]="environment.homeImageUrl + 'wadhwani-logo.svg'" alt="Logo" class="w-[60px] h-4" />
                            <h5 class="text-[#BC2328] text-[8px] text-center font-semibold">
                              ইন্টারভিউয়ের কল পেতে<br>
                              ফ্রিতে রেজিস্ট্রেশন করুন
                            </h5>
                          </div>
                          <span class="course-title">{{ slide.TopicName | truncate:60}}</span>
                        </div>
                        <div class="card-right bg-[#8B4200] rounded-r">
                          <div class="flex flex-col">
                            <div class="flex items-center gap-1">
                              <img [src]="environment.homeImageUrl + 'taka-sign.svg'" alt="Price Icon" class="text-[10px] sm:text-sm" />
                               
                              <span class="text-[10px] lg:text-xs">{{ slide.TrainingFee }} BDT</span>
                            </div>
                            @if(slide.TName){
                              <div class="flex gap-1">
                                <img [src]="environment.homeImageUrl + 'instructor-icon.svg'" alt="Instructor Icon" class="sm:icon w-3 h-3" />
                                <span class="text-[8px] sm:text-[10px] lg:text-[10px]">{{ slide.TName }}</span>
                              </div>
                            }
                          </div>
                          <button class="self-end w-full text-center rounded text-[8px] sm:text-[10px] font-semibold bg-[#ffffff33] px-3 py-1">Register Now</button>
                        </div>
                      } @else {
                        <div 
                          [style.background-image]="backgroundImageUrl"
                          class="card-left rounded-l">
                          <img [src]="environment.homeImageUrl + 'elearning_logo.svg'" alt="Logo" class="w-[60px] h-4" />
                          <span class="course-title">{{ slide.TopicName | truncate:60}}</span>
                        </div>
                        <div class="card-right bg-[#0d64a4e6] rounded-r">
                          <div class="flex flex-col">
                            <div class="flex items-center gap-1">
                              <img [src]="environment.homeImageUrl + 'taka-sign.svg'" alt="Price Icon" class="text-[10px] sm:text-sm" />
                              <span class="text-[10px] lg:text-xs">{{ slide.TrainingFee }} BDT</span>
                            </div>
                            @if(slide.TName){
                              <div class="flex gap-1">
                                <img [src]="environment.homeImageUrl + 'instructor-icon.svg'" alt="Instructor Icon" class="sm:icon w-3 h-3" />
                                <span class="text-[8px] sm:text-[10px] lg:text-[10px]">{{ slide.TName }}</span>
                              </div>
                            }
                          </div>
                          <button class="self-end w-full text-center rounded text-[8px] sm:text-[10px] font-semibold bg-[#ffffff33] px-3 py-1">Register Now</button>
                        </div>
                      }
                    </div>
                  </a>
            }
            
          </div>
      }
        
      </div>
    </div>
  
    <button (click)="prevSlide()" class="cursor-pointer text-[#A0A0A0] hover:text-[#595959] absolute top-[0.5rem] right-16">
      <span class="text-sm icon-angle-left-o"></span>
    </button>
    <button (click)="nextSlide()" class="cursor-pointer text-[#A0A0A0] hover:text-[#595959] absolute top-1.5 right-4 rotate-180">
      <span class="text-sm icon-angle-left-o"></span>
    </button>
  </div>
